/** numberType = Home, Work, Cell, not always required (options.requireNumberType) */
/** type = Domestic, International, DSN */

import { REQUIRED } from 'constants/errors';
import { ValidateJSModel, TelephoneModel } from 'forms/shared/types';

const phoneModelValidator: ValidateJSModel<TelephoneModel> = {
  extension: {
    format: { pattern: /^\d*$/, message: 'error.telephone.pattern' },
  },

  name: {},

  showTimeOfDay: {},

  noNumber: (value, attributes, attributeName, options) => {
    if (options.requireNumber) {
      return {
        inclusion: {
          within: [false, ''],
          message: REQUIRED,
        },
      };
    }

    return {};
  },

  numberType: (value, attributes, attributeName, options) => {
    const { requireNumber, requireNumberType } = options;
    if (!requireNumberType || (!requireNumber && attributes.noNumber === true)) { return {}; }

    return { presence: true };
  },

  timeOfDay: (value, attributes, attributeName, options) => {
    if (!options.requireNumber && attributes.noNumber === true) { return {}; }

    return { presence: true };
  },

  type: (value, attributes, attributeName, options) => {
    if (!options.requireNumber && attributes.noNumber === true) { return {}; }

    return {
      inclusion: {
        within: ['Domestic', 'DSN', 'International'],
        message: REQUIRED,
      },
    };
  },

  number: (value, attributes, attributeName, options) => {
    if (!options.requireNumber && attributes.noNumber === true) { return {}; }

    switch (attributes.type) {
      case 'Domestic':
      case 'DSN':
        return {
          presence: true,
          format: { pattern: /^((?!(0))\d{10})$/, message: 'error.telephone.pattern' },
        };
      case 'International':
        return {
          presence: true,
          format: { pattern: /^\d{4,20}$/, message: 'error.telephone.pattern' },
        };
      default: {
        return { presence: true };
      }
    }
  },
};

export default phoneModelValidator;
